import { BANNED_WORDS_ERROR } from '../constants'
import { LANDING_PAGE_TYPE_CAST_TABLE } from '../WizardCampaign/steps/LandingPageStep/constants'

import {
  ADD_LANDING_PAGE_ASYNC,
  CHANGE_LANDING_PAGE_PROPERTY,
  EDIT_LANDING_PAGE_ASYNC,
  GET_LANDING_PAGE_ASYNC,
  RESET_LANDING_PAGE,
} from './constants'

const DEFAULT_LANDING_PAGE = {
  contents: [],
  title: '',
  locale: undefined,
  trainingType: LANDING_PAGE_TYPE_CAST_TABLE.FULL_TUTORIAL,
  name: '',
}

export default function () {
  const initialState = {
    error: null,
    saveLoader: false,
    getLandingPageLoader: false,
    landingPage: DEFAULT_LANDING_PAGE,
    bannedWordsError: null,
  }

  let chosenContent

  return (state = initialState, action) => {
    let isBannedWordsError
    let newError

    switch (action.type) {
      case RESET_LANDING_PAGE:
        return {
          ...initialState,
        }
      case GET_LANDING_PAGE_ASYNC.INITIATE:
        return {
          ...state,
          getLandingPageLoader: true,
          error: null,
        }
      case GET_LANDING_PAGE_ASYNC.SUCCESS:
        chosenContent = action.payload.landingPage.contents.find(
          (el) => el.locale === action.payload.landingPage.locale[0]
        ) || {
          content: '',
          page_title: '',
        }

        return {
          ...state,
          getLandingPageLoader: false,
          landingPage: {
            id: action.payload.landingPage.id,
            name: action.payload.landingPage.name,
            trainingType: action.payload.landingPage.training_type,
            title: chosenContent.page_title,
            content: chosenContent.content,
            locale: action.payload.landingPage.locale[0],
            contents: action.payload.landingPage.contents,
          },
        }
      case GET_LANDING_PAGE_ASYNC.ERROR:
        return {
          ...state,
          getLandingPageLoader: false,
          error: action.error.response?.message || action.error.detail,
        }
      case ADD_LANDING_PAGE_ASYNC.INITIATE:
        return {
          ...state,
          saveLoader: true,
          error: null,
          bannedWordsError: null,
        }
      case ADD_LANDING_PAGE_ASYNC.SUCCESS:
        return {
          ...state,
          saveLoader: false,
          error: null,
          bannedWordsError: null,
        }
      case ADD_LANDING_PAGE_ASYNC.ERROR: {
        newError = {
          error: null,
          bannedWordsError: null,
        }

        if (action.error.response?.landing_page_content) {
          Object.values(action.error.response?.landing_page_content).forEach((value) => {
            if (value.includes(BANNED_WORDS_ERROR)) {
              isBannedWordsError = true
            }
          })
        }

        if (isBannedWordsError) {
          newError.bannedWordsError = action.error.detail
        } else {
          newError.error = action.error.detail
        }

        return {
          ...state,
          ...newError,
          saveLoader: false,
        }
      }
      case EDIT_LANDING_PAGE_ASYNC.INITIATE:
        return {
          ...state,
          saveLoader: true,
          error: null,
          bannedWordsError: null,
        }
      case EDIT_LANDING_PAGE_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          saveLoader: false,
          bannedWordsError: null,
        }
      case EDIT_LANDING_PAGE_ASYNC.ERROR: {
        newError = {
          error: null,
          bannedWordsError: null,
        }

        if (action.error.response?.landing_page_content) {
          Object.values(action.error.response?.landing_page_content).forEach((value) => {
            if (value.includes(BANNED_WORDS_ERROR)) {
              isBannedWordsError = true
            }
          })
        }

        if (isBannedWordsError) {
          newError.bannedWordsError = action.error.detail
        } else {
          newError.error = action.error.detail
        }

        return {
          ...state,
          ...newError,
          saveLoader: false,
        }
      }
      case CHANGE_LANDING_PAGE_PROPERTY:
        return {
          ...state,
          landingPage: {
            ...state.landingPage,
            [action.payload.propertyName]: action.payload.value,
          },
        }
      default:
        return state
    }
  }
}
